import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

import { UserResponse } from '../../models/userdetails';

import { CommonService } from '../../common/services/common.service';
import { LoginService } from './login.service';
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnChanges {

  @Input() clearValues = false;
  @Input() onStepsPage:boolean = false;
  @Output() onCreateAccount: EventEmitter<any> = new EventEmitter <any> ();
  @Output() onForgotPassword: EventEmitter<any> = new EventEmitter<any>();
  loginDetail = {'email': '', 'password': ''};
  bookingDetail = {'bookingNumber': '', 'lastName': ''};
  isLoginSuccess = true;
  isValid = true;

  constructor(private _router: Router, private _loginService: LoginService, private _commonService: CommonService) { }

  ngOnInit() {}

  ngOnChanges() {
    if (this.clearValues) {
      this.loginDetail.email = this.loginDetail.password = '';
      this.bookingDetail.bookingNumber = this.bookingDetail.lastName = '';
    }
  }

  validateLoginDetails() {
    this.isLoginSuccess = this.isValid = true;
    this.isValid = !this.loginDetail.email || !this.loginDetail.password ? false : true;
    if (this.isValid) { this.login(); }
  }

  showForgotPassword(){
    this.onForgotPassword.emit(true);
  }

  login() {
    this.isLoginSuccess = true;
    var UserObject = {
      email : this.loginDetail.email,
      password : this.loginDetail.password
    }
    this._loginService.login(UserObject).subscribe((response: UserResponse) => {
      if (response.message === 'success' && response.status) {
        this.storeLoginData(response.data);
        document.getElementById('login-register-modal-close-btn').click();
        $('.modal').modal('hide');
      } else {
        this.isLoginSuccess = false;
      }
    });
  }

  storeLoginData(data) {
    this._commonService.isLoggedIn.next(true);
    localStorage.setItem('isLogged', 'true');
    localStorage.setItem('userDetails',JSON.stringify(data));
    this._commonService.setUserDetails(data);
    
    // localStorage.setItem('userName', data.data.name);
    // localStorage.setItem('userId', data.data.id);
  }


  bookingDetails(){
    if(this.bookingDetail.bookingNumber != null && this.bookingDetail.lastName != null){
      this._router.navigate(['/userbooking/'+this.bookingDetail.bookingNumber],{
        queryParams:{
          'lastname':this.bookingDetail.lastName
        }
      });
      document.getElementById('login-register-modal-close-btn').click();
    }
  }

  registerAccount() {
    this.onCreateAccount.emit(true);
    // this._router.navigate(['/ticketvoordeel/register']);
  }

}
